import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom"; // ✅ FIXED
import style from './CreateProject.module.css';
import AdminNavBar from '../../NavBar/AdminNavBar';
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function CreateProject() {
    const apiUrl = process.env.REACT_APP_SERVER_URL;
    const { employeeId } = useParams();

    const [loadingUsers, setLoadingUsers] = useState(false);
    const [users, setUsers] = useState([]);
    const selectRef = useRef(null);
    const token = localStorage.getItem("token");

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        title: "",
        client: "",
        clientEmail: "",
        description: "",
        platform: "",
        team: "",
        type: "",
        status: "",
        priority: "",
        progress: "",
        employeeId: [],
        manager: "",
        createdBy: employeeId,
        startDate: "",
        endDate: "",
        deadLine: "",
        budget: "",
        spent: "",
        pending: "",
    });

    // Fetch all users
    useEffect(() => {
        setLoadingUsers(true);
        fetch(`${apiUrl}/users`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then(res => res.json())
            .then(data => {
                setUsers(data.users || []);
                setLoadingUsers(false);
            })
            .catch(err => {
                setLoadingUsers(false);
            });
    }, [apiUrl]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle employee selection
    const handleSelectEmployees = (e) => {
        const selectedId = e.target.value;
        if (selectedId && !formData.employeeId.includes(selectedId)) {
            setFormData(prev => ({
                ...prev,
                employeeId: [...prev.employeeId, selectedId]
            }));
        }
        e.target.value = "";
    };

    // Remove last selected employee
    const handleRemoveLast = () => {
        setFormData(prev => ({
            ...prev,
            employeeId: prev.employeeId.slice(0, -1)
        }));
    };

    // Filter users to show only employees not yet selected
    const availableUsers = users.filter(
        u => u.role === "Employee" && !formData.employeeId.includes(u.employeeId)
    );

    const managerUsers = users.filter((u) => u.role === "Manager");

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!apiUrl) return alert("API URL is not working");

        try {
            const response = await fetch(`${apiUrl}/projects/create-project`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (!response.ok) {
                alert(`Error: ${data.message}`);
                navigate(`/admin-dashboard/${employeeId}/all-projects`);
            } else {
                alert("✅ Project created successfully!");
                navigate(`/admin-dashboard/${employeeId}/all-projects`);
                // Reset form
                setFormData({
                    title: "",
                    client: "",
                    clientEmail: "",
                    description: "",
                    platform: "",
                    team: "",
                    type: "",
                    status: "",
                    priority: "",
                    progress: "",
                    employeeId: [],
                    manager: "",
                    createdBy: employeeId,
                    startDate: "",
                    endDate: "",
                    deadLine: "",
                    budget: "",
                    spent: "",
                    pending: "",
                });
            }
        } catch (err) {
            alert("❌ Network error. Try again later.");
        }
    };

    return (
        <>
            <AdminNavBar />
            <div className="container mt-lg-1 mb-5">
                <div className="row">

                    {/* BreadCrumb Linkss */}
                    <div className="col-8 col-lg-5 mb-3">
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}`}
                            name="Dashboard"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/all-projects`}
                            name="All Projects"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/create-project`}
                            name="Create New Project"
                        />
                    </div>

                    <div className={style.createProjectPage}>
                        <form onSubmit={handleSubmit} onKeyDown={(e) => {
                            if (e.key === "Enter") e.preventDefault();
                        }}
                            className="row g-lg-3 p-lg-4">

                            {/* title */}
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Title</label>
                                <input
                                    type="text"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* client */}
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">client</label>
                                <input
                                    type="text"
                                    name="client"
                                    value={formData.client}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* description */}
                            <div className="col-md-12">
                                <label className="form-label fw-semibold">Description</label>
                                <textarea
                                    type="text"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* platform */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Platform</label>

                                <select
                                    name="platform"
                                    className={`form-select ${style.formSelect}`}
                                    value={formData.platform}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Platform</option>
                                    <option value="MERN">MERN</option>
                                    <option value="MEAN">MEAN</option>
                                    <option value="Java">Java</option>
                                    <option value="React">React</option>
                                    <option value="Python">Python</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            {/* team */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Team</label>
                                <select
                                    name="team"
                                    className={`form-select ${style.formSelect}`}
                                    value={formData.team}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Team</option>
                                    <option value="MERN Development">MERN Development</option>
                                    <option value="Backend Development">Backend Development</option>
                                    <option value="FrontEnd Development">FrontEnd Development</option>
                                    <option value="UI Development">UI Development</option>
                                    <option value="UI Designing">UI Designing</option>
                                    <option value="UI/UX Design">UI/UX Design</option>
                                    <option value="QA Testing">QA Testing</option>
                                    <option value="DevOps">DevOps</option>
                                    <option value="React">React</option>
                                </select>
                            </div>

                            {/* type */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Type</label>
                                <select
                                    name="type"
                                    className={`form-select ${style.formSelect}`}
                                    value={formData.type}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Type</option>
                                    <option value="Planning">Planning</option>
                                    <option value="Development">Development</option>
                                    <option value="Designing">Designing</option>
                                    <option value="Testing">Testing</option>
                                    <option value="Deployment">Deployment</option>
                                    <option value="Maintenance">Maintenance</option>
                                </select>
                            </div>

                            {/* status */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Status</label>
                                <select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select Status</option>
                                    <option value="In Progress">In Progress</option>
                                    <option value="Completed">Completed</option>
                                    <option value="Pending">Pending</option>
                                </select>
                            </div>

                            {/* priority */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Priority</label>
                                <select
                                    name="priority"
                                    value={formData.priority}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select Priority</option>
                                    <option value="High">High</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Low">Low</option>
                                </select>
                            </div>

                            {/* project Completion */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Project Level (%)</label>
                                <input
                                    type="number"
                                    name="progress"
                                    value={formData.progress}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* Employee selection */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Add Employee</label>
                                <select
                                    ref={selectRef}
                                    className="form-select"
                                    onChange={handleSelectEmployees}
                                    value={formData.employeeId}
                                >
                                    <option value="">Select Employee</option>
                                    {loadingUsers ? (
                                        <option disabled>Loading...</option>
                                    ) : (
                                        availableUsers.map((u) => (
                                            <option key={u.employeeId} value={u.employeeId}>
                                                {u.employeeId} - {u.firstName}  {u.lastName}
                                            </option>
                                        ))
                                    )}
                                </select>
                            </div>

                            {/* manager */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Manager</label>
                                <select
                                    name="manager"
                                    value={formData.manager}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select Manager</option>
                                    {managerUsers.map((user) => (
                                        <option key={user.employeeId} value={user.name}>
                                            {user.employeeId} - {user.firstName}                                     </option>
                                    ))}
                                </select>
                            </div>

                            {/* created By */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Created By</label>
                                <input
                                    type="text"
                                    name="createdBy"
                                    value={formData.createdBy}
                                    onChange={handleChange}
                                    className="form-control"
                                    disabled
                                />
                            </div>

                            {/* Assigned Employees display */}
                            <div className="col-md-8 mt-3">
                                <label htmlFor="employeeId" className="form-label fw-semibold">
                                    Assigned Employees
                                </label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        id="employeeId"
                                        name="employeeId"
                                        className="form-control"
                                        value={formData.employeeId?.join(", ") || ""}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                employeeId: e.target.value
                                                    .split(",")
                                                    .map((id) => id.trim())
                                                    .filter(Boolean),
                                            })
                                        }
                                        placeholder="Enter employee IDs separated by commas"
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={handleRemoveLast}
                                        disabled={formData.employeeId.length === 0}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>

                            {/* client email */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Client Email</label>
                                <input
                                    type="text"
                                    name="clientEmail"
                                    value={formData.clientEmail}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* start date */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Start Date</label>
                                <input
                                    type="date"
                                    name="startDate"
                                    value={formData.startDate ? formData.startDate.substring(0, 10) : ""}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* end date */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">End Date</label>
                                <input
                                    type="date"
                                    name="endDate"
                                    value={formData.endDate ? formData.endDate.substring(0, 10) : ""}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* deadline */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Deadline </label>
                                <input
                                    type="date"
                                    name="deadLine"
                                    value={formData.deadLine ? formData.deadLine.split('T')[0] : ''}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* budget */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Budget</label>
                                <input
                                    type="text"
                                    name="budget"
                                    value={formData.budget}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* spent */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Spent</label>
                                <input
                                    type="text"
                                    name="spent"
                                    value={formData.spent}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* pending */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Pending</label>
                                <input
                                    type="text"
                                    name="pending"
                                    value={formData.pending}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* Submit */}
                            <div className="col-12 mt-4 text-center">
                                <button type="submit" className="btn btn-primary btn-sm">
                                    Create Project
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
